var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { LoaderDots } from '../LoaderDots';
import { ButtonLoadingContainer } from './Button.style';
var ChildrenContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: 0;\n"], ["\n  opacity: 0;\n"])));
var ButtonLoaderContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var ButtonLoader = function (_a) {
    var children = _a.children, large = _a.large, small = _a.small, props = __rest(_a, ["children", "large", "small"]);
    return (React.createElement(ButtonLoaderContainer, __assign({}, props),
        React.createElement(LoaderDots, { large: large, small: small }),
        React.createElement(ChildrenContainer, null, children)));
};
export var LoadingContainer = function (_a) {
    var children = _a.children, loading = _a.loading, props = __rest(_a, ["children", "loading"]);
    return loading ? (React.createElement(ButtonLoadingContainer, null,
        React.createElement(ButtonLoader, __assign({}, props), children))) : (React.createElement(React.Fragment, null, children));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=LoadingContainer.js.map